import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router) {

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.addAuth(req).pipe(mergeMap(reqWithAuth => {
      return next.handle(reqWithAuth)
        .pipe(
          catchError((error: HttpErrorResponse) => {
            if (error?.status === 401) {
              if (this.router.url !== '/login' && this.router.url !== '/account/manage') {
                this.authService.logout().then(res => {
                  this.router.navigate(['/login']);
                });
              }
              return throwError(error);
            }
            return throwError(error);
          })
        );
    }));

  }

  /**
   * Adds Authorization header (if available) and returns Observale for intercept chain to continue
   * If fails to retrieve authorization info, return request and let error handling occur.
   *
   * @param req HttpRequest<any>
   * @returns Observable<HttpRequest<any>>
   */
  addAuth(req: HttpRequest<any>) {
    const authPromise = this.authService.getAuthHeaders().then(res => {
      const tokenReq = req.clone({
        headers: req.headers.set('Authorization', res)
      });
      return tokenReq;
    }).catch(err => {
      console.error('Failed to add Auth Header', err);
      return req;
    });

    return from(authPromise);
  }

}
